import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./PopupMessage.css";
import { Check2Circle, XCircle } from "react-bootstrap-icons";

const PopupMessage = ({ isVisible, type, message, onClose }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className={`popup-message ${type}`}
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <div className="popup-content">
            {type === "success" ? <Check2Circle className="popup-icon" /> : <XCircle className="popup-icon" />}
            <p>{message}</p>
          </div>
          <div className="popup-progress">
            <motion.div
              className="progress-bar"
              initial={{ width: "100%" }}
              animate={{ width: "0%" }}
              transition={{ duration: 3, ease: "linear" }}
              onAnimationComplete={onClose}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PopupMessage;
